module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mic":"Microphone","camera":"Camera","settings":"Settings"}}')
  delete Component.options._Ctor
}
